// BabyMobile.ca redesign — sticky header scroll shadow
(function () {
  var header = document.querySelector('header-component');
  if (!header) return;

  function update() {
    header.classList.toggle('rd-header-scrolled', window.scrollY > 12);
  }

  update();
  window.addEventListener('scroll', update, { passive: true });
})();

// BabyMobile.ca redesign — horizontal scroll-snap carousels sometimes start
// pre-scrolled past their own leading padding (browser scroll-snap init
// quirk, re-triggered once images finish loading and reflow the page), so
// force them back to their true left edge at every point that could disturb it.
(function () {
  function resetScrollers() {
    document.querySelectorAll('.rd-bestseller-scroll, .rd-reviews-masonry').forEach(function (el) {
      if (el.scrollLeft !== 0) el.scrollLeft = 0;
    });
  }

  resetScrollers();
  window.addEventListener('load', resetScrollers);
  window.setTimeout(resetScrollers, 300);
  window.setTimeout(resetScrollers, 1000);
})();

// BabyMobile.ca redesign — scroll-reveal for sections below the fold
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var main = document.getElementById('MainContent');
  if (!main) return;

  var targets = Array.prototype.filter.call(main.children, function (el) {
    return el.classList.contains('shopify-section') && !el.querySelector('[data-noreveal]');
  });

  if (!targets.length) return;

  targets.forEach(function (el) {
    el.classList.add('rd-reveal');
  });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('rd-reveal-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -80px 0px' }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
})();

// BabyMobile.ca redesign — sticky buy bar on product pages
(function () {
  var bar = document.querySelector('[data-rd-sticky-buy]');
  if (!bar) return;

  var SHOW_AFTER = 620;

  function update() {
    bar.hidden = window.scrollY <= SHOW_AFTER;
  }

  update();
  window.addEventListener('scroll', update, { passive: true });
})();

// BabyMobile.ca redesign — gift note field: only submit the note when the
// toggle is on, and keep the live character counter in sync.
(function () {
  var toggle = document.querySelector('.rd-gift-toggle-input');
  var textarea = document.querySelector('.rd-gift-note-textarea');
  var counter = document.querySelector('[data-rd-gift-note-count]');
  if (!toggle || !textarea) return;

  var MAX_LENGTH = textarea.getAttribute('maxlength') || 200;

  function syncDisabled() {
    textarea.disabled = !toggle.checked;
  }

  function syncCounter() {
    if (counter) counter.textContent = textarea.value.length;
  }

  syncDisabled();
  syncCounter();
  toggle.addEventListener('change', syncDisabled);
  textarea.addEventListener('input', syncCounter);
})();
